import { COLORS, TYPE, SPACE } from '../tokens'

// Section 1: TL;DR lead paragraph.
// Reads from review.findings.overallTake if present, otherwise falls back to
// deriving a short summary from the highest-confidence high-severity gap.
function deriveTake(review, findings) {
  if (review?.findings?.overallTake) return review.findings.overallTake
  const topGap = findings.find(f => f.finding_type === 'gap' && f.severity === 'high')
  if (topGap) return topGap.detail
  return 'The Specialist review is complete. See the sections below for detail.'
}

export default function TheTake({ review, findings }) {
  return (
    <section style={{ maxWidth: SPACE.sectionMaxWidth, margin: '0 auto' }}>
      <div style={{
        borderTop: `2px solid ${COLORS.accent}`,
        width: '48px',
        marginBottom: '20px'
      }} />
      <p style={{ ...TYPE.lead, color: COLORS.bodyText }}>
        {deriveTake(review, findings)}
      </p>
    </section>
  )
}
